import { render, staticRenderFns } from "./MyMenusDay.vue?vue&type=template&id=2bab4ef1&scoped=true"
import script from "./MyMenusDay.vue?vue&type=script&lang=js"
export * from "./MyMenusDay.vue?vue&type=script&lang=js"
import style0 from "./MyMenusDay.vue?vue&type=style&index=0&id=2bab4ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab4ef1",
  null
  
)

export default component.exports